module.exports = __webpack_public_path__ + "static/img/salepage-stk-shipment_04.4575f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/shipment/salepage-stk-shipment_04.jpg
// module id = fIjj
// module chunks = 134